<script>
import {defineComponent} from "vue"
import ContactFieldEmail from "@/components/contacts/fields/ContactFieldEmail.vue"
import ContactFieldMobile from "@/components/contacts/fields/ContactFieldMobile.vue"
import ContactFieldName from "@/components/contacts/fields/ContactFieldName.vue"
import ContactFieldPhone from "@/components/contacts/fields/ContactFieldPhone.vue"
import QrCodeContact from "@/components/toolkit/QrCodeContact.vue";

export default defineComponent({
  name: "ClientPopup",
  components: { QrCodeContact, ContactFieldPhone, ContactFieldName, ContactFieldMobile, ContactFieldEmail},
  permissions: ["Read Client", "Delete Contact", ...ContactFieldName.permissions, ...ContactFieldPhone.permissions, ...ContactFieldMobile.permissions, ...ContactFieldEmail.permissions],
  props: {
    value: {
      type: Boolean,
    },
    selectedContact: {
      type: Object,
      required: true,
    },
    selectedClient: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    removeDialog: false,
  }),
  computed: {
    firstName() {
      const name = this.$splitName(this.selectedContact.Name)
      return name.first
    },
    lastName() {
      const name = this.$splitName(this.selectedContact.Name)
      return name.last
    }
  },
  methods:{
    close(){
      this.$emit("input", false)
      this.dialog = false
    },
    removeContact(){
      const uuid = this.selectedContact.UUID
      this.$WfmApi.delete(`client.api/contact/${uuid}`).then(() => {
        this.$notify.toast("Contact deleted")
        this.removeDialog = false
        const contacts = this.selectedClient.Contacts.Contact
        const idx = contacts.findIndex(contact => contact.UUID === uuid)
        if (idx !== -1) {
          contacts.splice(idx, 1)
        }
        this.close()
      })
    }
  },
  watch: {
    selectedContact: {
      handler: function () {
        this.dialog = true
      },
      deep: true,
    },
    value: {
      handler: function () {
        this.dialog = this.value
      },
      deep: true,
    },
  },
})
</script>

<template>
 <div>
  <v-dialog v-model="dialog" max-width="500" :key="selectedContact.UUID">
    <v-card>
      <v-card-title class="headline">{{ selectedContact.Name }}</v-card-title>
      <v-card-text>
        <v-simple-table>
          <template v-slot:default>
            <tbody>
            <tr>
              <th class="text-left">Name</th>
              <td>
                <ContactFieldName :contact="selectedContact" :clientId="selectedClient.UUID"/>
              </td>
            </tr>
            <tr>
              <th class="text-left">Phone</th>
              <td>
                <ContactFieldPhone :contact="selectedContact" :clientId="selectedClient.UUID"/>
              </td>
            </tr>
            <tr>
              <th class="text-left">Mobile</th>
              <td>
                <ContactFieldMobile :contact="selectedContact" :clientId="selectedClient.UUID"/>
              </td>
            </tr>
            <tr>
              <th class="text-left">Email</th>
              <td>
                <ContactFieldEmail :contact="selectedContact" :clientId="selectedClient.UUID"/>
              </td>
            </tr>
            <tr>
              <th class="text-left">QR Code</th>
              <td>
                <QrCodeContact :key="selectedContact.UUID"
                       :firstName="firstName"
                       :lastName="lastName"
                       :workEmail="selectedContact.Email ? selectedContact.Email : ''"
                       :workPhone="selectedContact.Phone ? selectedContact.Phone : ''"
                       :homePhone="selectedContact.Mobile ? selectedContact.Mobile : ''"
                       :orgName="selectedClient.Name ? selectedClient.Name : ''"
                />
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>

      <v-card-actions>
        <v-btn color="red darken-1" text @click="removeDialog = true">
          Delete
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="close">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="removeDialog" width="500">
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        Confirm
      </v-card-title>

      <v-card-text>
        <p>Are you sure you want to delete {{ selectedContact.Name }}?</p>
      </v-card-text>

      <v-card-actions>
        <v-btn color="primary" text @click="removeDialog = false">
          No
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="removeContact">
          Yes
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
 </div>
</template>

<style scoped>

</style>